export const smartAdminAccentTokens = {
  earth: {
    contrastText: '#ffffff',
    dark: '#0f78c8',
    light: '#7ac1f8',
    main: '#2198f3',
    shadow: 'rgba(33, 152, 243, 0.35)',
  },
  primary: {
    contrastText: '#ffffff',
    dark: '#0f78c8',
    light: '#7ac1f8',
    main: '#2198f3',
    shadow: 'rgba(33, 152, 243, 0.35)',
  },
  secondary: {
    contrastText: '#ffffff',
    dark: '#565e64',
    light: '#8f959a',
    main: '#6c757d',
    shadow: 'rgba(108, 117, 125, 0.35)',
  },
  success: {
    contrastText: '#ffffff',
    dark: '#3f980b',
    light: '#97d970',
    main: '#52bf11',
    shadow: 'rgba(82, 191, 17, 0.3)',
  },
  info: {
    contrastText: '#ffffff',
    dark: '#7e22a7',
    light: '#cd86e6',
    main: '#ab35d6',
    shadow: 'rgba(171, 53, 214, 0.3)',
  },
  warning: {
    contrastText: '#212529',
    dark: '#cc7805',
    light: '#ffc271',
    main: '#ff9a13',
    shadow: 'rgba(255, 154, 19, 0.3)',
  },
  danger: {
    contrastText: '#ffffff',
    dark: '#c41946',
    light: '#f5819c',
    main: '#ee2d5a',
    shadow: 'rgba(238, 45, 90, 0.3)',
  },
  fusion: {
    contrastText: '#ffffff',
    dark: '#2c3136',
    light: '#6f767d',
    main: '#434a51',
    shadow: 'rgba(67, 74, 81, 0.3)',
  },
} as const

export type CodesignThemeName = keyof typeof smartAdminAccentTokens
